module.exports = __webpack_public_path__ + "media/slide3/contractMediaSlide3Part3-b26ca5e0.png";